'use strict';
// @flow

export default class ShapesController {
  $state
  $scope
  $rootScope
  canvas

  /*@ngInject*/
  constructor($state, $scope, $rootScope, Canvas) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.canvas = Canvas;
  }

  $onInit = () => {
    this.$scope.$parent.isZIndexToolbarVisible = false;
    this.$scope.isToolboxVisible = false;
    this.$scope.currentItem = null;

    this.$scope.modelBinding = {
      shape: 'rectangle',
      width: 0,
      height: 0,
      backgroundColor: '',
      rotation: 0,
      borderWidth: 0,
      borderColor: '#ffffff'
    };

    this.$scope.availableShapes = [
      { name: 'Rechteck', value: 'rectangle', icon: 'crop_16_9' },
      { name: 'Quadrat', value: 'square', icon: 'crop_din' },
      { name: 'Kreis', value: 'circle', icon: 'panorama_fish_eye' },
      { name: 'Dreieck', value: 'triangle', icon: 'details' }
    ];

    this.canvas.events.addListener('canvas.onItemSelected', this.onCanvasItemSelected);
    this.canvas.events.addListener('canvas.onItemUnselected', this.onCanvasItemUnselected);
    const onArrange = this.$rootScope.$on('onArrange', this.onArrange);

    this.$scope.$on('$destroy', () => {
      this.canvas.events.removeListener('canvas.onItemSelected', this.onCanvasItemSelected);
      this.canvas.events.removeListener('canvas.onItemUnselected', this.onCanvasItemUnselected);
      onArrange();
    });
  }

  addShape = () => {
    this.canvas.addShape();
  }

  removeShape = () => {
    this.canvas.removeShape(this.$scope.currentItem);
  }

  onCanvasItemSelected = e => {
    let item = e.item;

    if(item.type != 'shape') {
      this.$rootScope.$apply(() => {
        this.$scope.$parent.isZIndexToolbarVisible = false;
        this.$scope.isToolboxVisible = false;
      });
      return;
    }

    this.$rootScope.safeApply(() => {
      this.$scope.$parent.isZIndexToolbarVisible = true;
      this.$scope.isToolboxVisible = true;
      this.$scope.currentItem = item;

      this.$scope.modelBinding.shape = item.shape;
      this.$scope.modelBinding.width = item.width;
      this.$scope.modelBinding.height = item.height;
      this.$scope.modelBinding.rotation = item.rotation;

      this.$scope.modelBinding.backgroundColor = item.backgroundColor;
      this.$scope.modelBinding.backgroundOpacity = item.backgroundOpacity * 100;

      this.$scope.modelBinding.borderWidth = item.borderWidth;
      this.$scope.modelBinding.borderColor = item.borderColor;
      this.$scope.modelBinding.shadowWidth = item.shadowWidth;
    });
  }

  onCanvasItemUnselected = e => {
    this.$rootScope.safeApply(() => {
      this.$scope.$parent.isZIndexToolbarVisible = false;
      this.$scope.isToolboxVisible = false;
      this.$scope.currentItem = null;
    });
  }

  onShapeChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.shape = this.$scope.modelBinding.shape;
    this.canvas.renderStage();
  }

  onWidthChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.width = this.$scope.modelBinding.width;
    this.canvas.renderStage();
  }

  onHeightChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.height = this.$scope.modelBinding.height;
    this.canvas.renderStage();
  }

  onRotationChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.rotation = this.$scope.modelBinding.rotation;
    this.canvas.renderStage();
  }

  onBackgroundColorChanged = (hsb, hex, rgb) => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.backgroundColor = '#' + hex;
    this.canvas.renderStage();
  }

  onBackgroundOpacityChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.backgroundOpacity = this.$scope.modelBinding.backgroundOpacity / 100;
    this.canvas.renderStage();
  }

  onBorderWidthChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.borderWidth = this.$scope.modelBinding.borderWidth;
    this.canvas.renderStage();
  }

  onBorderColorChanged = (hsb, hex, rgb) => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.borderColor = '#' + hex;
    this.canvas.renderStage();
  }

  onShadowWidthChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.shadowWidth = this.$scope.modelBinding.shadowWidth;
    this.canvas.renderStage();
  }

  onArrange = (event, action) => {
    if(!this.$scope.currentItem) return;
    this.canvas.applyZIndex(this.$scope.currentItem, action);
  }
}



// WEBPACK FOOTER //
// ./client/app/configurator/shapes/shapes.controller.js